module.exports = __webpack_public_path__ + "static/salesforce-b40df5d7b9ba96cf2a839a6a715685da.svg";